import React from 'react';
import AppHeader from './AppHeader';
import AppSidebar from './AppSidebar';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
// Ensure useSidebarContext is imported if AppLayout directly uses it,
// otherwise, AppHeader or AppSidebar might be using it.
// For now, we assume AppHeader/AppSidebar handle their own interactions with the context.

const AppLayout = ({ children }) => {
  useAuth();
  useNavigate(); // Required for routing context

  // The TailAdmin template might use a context here to control sidebar visibility
  // or pass props to AppSidebar and AppHeader. For now, this is a basic structure.
  // We are relying on AppSidebar and AppHeader to use the useSidebarContext internally if needed.

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-boxdark-2 dark:text-bodydark">
      <div className="flex h-screen overflow-hidden">
        {/* Sidebar */}
        <AppSidebar />

        {/* Main Content */}
        <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
          <AppHeader />
          <main className="flex-1 p-4 md:p-6 2xl:p-10">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};

export default AppLayout; 